module.exports = __webpack_public_path__ + "static/img/slider2.b3a6509.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/slider2.jpg
// module id = BkM8
// module chunks = 1